import React, { memo } from 'react';
import { SvgUniqueID } from '@financial/svg-manager';

const IconCloseRound = /*#__PURE__*/memo(_ref => {
  let {
    fill = '#222',
    opacity = '1',
    width = '100%',
    height = '100%',
    viewBox = '0 0 13 13',
    id,
    style = {}
  } = _ref;
  return /*#__PURE__*/React.createElement(SvgUniqueID, {
    id: id
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: viewBox,
    style: style
  }, /*#__PURE__*/React.createElement("g", {
    fill: fill,
    opacity: opacity
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.236 1.375l11.39 11.39a.805.805 0 101.138-1.14L1.374.235a.805.805 0 00-1.138 1.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.764 1.375l-11.39 11.39a.805.805 0 11-1.138-1.14L11.626.235a.805.805 0 011.138 1.14z"
  }))));
});

export { IconCloseRound as default };
